import styled from 'styled-components';

export const StyledOnboardingScreenFtuxWrapper = styled.div`
    display: flex;
    height: 100%;
    padding: 0 48px;
    align-items: center;
    gap: 100px;
    flex-wrap: wrap-reverse;
    @media (max-width: 768px) {
        flex-wrap: nowrap;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 20px 0;
        gap: 16px;
        min-height: 100dvh;
    }
`;

export const StyledOnboardingScreenFtuxItem = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 40px;
    min-height: 350px;
    min-width: 300px;
    @media (max-width: 768px) {
        min-height: unset;
        min-width: unset;
        width: 100%;
        gap: 20px;
    }
`;

export const StyledOnboardingScreenImage = styled.img`
    width: 100%;
    height: 100%;
    flex: 1;
    @media (max-width: 768px) {
        max-height: 40vh;
        object-fit: contain;
    }
`;

export const StyledOnboardingScreenItemHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
    @media (max-width: 768px) {
        gap: 20px;
    }
`;

export const StyledOnboardingScreenItemHeaderBadgeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledOnboardingScreenItemColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    @media (max-width: 768px) {
        gap: 12px;
    }
`;

export const StyledOnboardingScreenItemHeaderBadge = styled.div`
    border-radius: 50px;
    padding: 4px 12px;
    background-color: ${(p) => p.theme.colors.mutedTransparent};
    width: fit-content;
`;

export const StyledOnboardingScreenCTA = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    width: fit-content;
    @media (max-width: 768px) {
        width: 90%;
    }
`;

export const StyledOnboardingScreenBottomBar = styled.div`
    display: none;
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.white};
        box-shadow: 0px -2px 8px rgba(55, 65, 81, 0.06);
        margin-top: 0;
    }
`;
